import React from 'react'
import { FormattedMessage } from 'react-intl'

const Dashboard: React.FC = () => {
  return (
    <div>
      <h1 className="text-2xl font-semibold text-gray-900">
        <FormattedMessage id="dashboard.heading" defaultMessage="Dashboard" />
      </h1>
      <p className="mt-2 text-sm text-gray-600">
        <FormattedMessage id="dashboard.body" defaultMessage="Placeholder page for upcoming family portal features." />
      </p>
    </div>
  )
}

export default Dashboard
